import type { ReactNode } from 'react';

export const symbol_drive_export: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M810-208 697-95q-9 9-21 9t-21-9q-9-9-9-21t9-21l112-113h-87q-13 0-21.5-8.5T650-280q0-13 8.5-21.5T680-310h160q13 0 21.5 8.5T870-280v160q0 13-8.5 21.5T840-90q-13 0-21.5-8.5T810-120v-88Zm-546 28h223L331-450H222l-58 99q-15 26-15 56.5t15 56.5q15 27 42 42.5t58 15.5Zm216-134 79-136H400l80 136ZM256-510h338l54-94-69-119q-15-26-41.5-41.5T480-780q-31 0-57.5 15T380-723L256-510Zm258 390H264q-48 0-88.5-23.5T111-208q-23-41-23-87t23-87l217-371q24-41 64-64t88-23q47 0 87.5 23t63.5 64l177 303q-17-2-35-2.5t-35 1.5l-55-94-97 167q-38 36-59.5 85T505-187q0 17 2 34t7 33Zm169-425Z"
		/>
	</svg>
);
